import Reveal from "./Reveal";

const MOMENTS = [
  {
    title: "Before or after an exit",
    body: "A founder is about to sell, or has just sold, and the proceeds are about to land in a personal name and a brokerage account. The structure that should receive them has not been designed yet.",
  },
  {
    title: "Across two or more countries",
    body: "Family members, companies or property sit in several jurisdictions, each with its own adviser. None of those advisers has ever spoken to the others, and nobody owns the whole picture.",
  },
  {
    title: "First generation to second",
    body: "The wealth was built in one lifetime. The family wants a structure the next generation can understand, run and defend, written in language they will actually read.",
  },
  {
    title: "Without the overhead",
    body: "The family has outgrown a private bank relationship but has no wish to hire a chief investment officer, lease an office and carry the fixed cost of a traditional single family office.",
  },
];

export default function WhoWeServe() {
  return (
    <section className="band band-canvas" id="who" data-testid="section-who">
      <div className="container">
        <Reveal>
          <div className="section-head">
            <p className="eyebrow">Who we serve</p>
            <div>
              <h2>
                Families at the point where a good wealth manager is no longer
                enough.
              </h2>
              <p className="lede">
                A family office is a decision about how a family holds, governs
                and passes on what it owns. Most families reach that decision
                at one of four moments.
              </p>
            </div>
          </div>
        </Reveal>
        <div className="who-grid" data-testid="who-grid">
          {MOMENTS.map((moment, index) => (
            <Reveal key={moment.title} delay={index * 0.06}>
              <article
                className="who-cell"
                data-testid={`who-cell-${index + 1}`}
              >
                <h3>{moment.title}</h3>
                <p>{moment.body}</p>
              </article>
            </Reveal>
          ))}
          <Reveal className="who-media" delay={0.1}>
            <img
              src="/who.jpg"
              alt="Two generations of a family reviewing a hand drawn ownership structure at a study table"
              width="628"
              height="785"
              loading="lazy"
              data-testid="who-image"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
